import { fieldTypeIcons, fieldTypeMessages, hasFieldTypeMessage } from '../../../constants/fieldType';
import { SkeletonDiv } from '../../common/SkeletonDiv';
import PropertyInformationPopoverValueRow from './PropertyInformationPopoverValueRow';
import I18n from 'I18n';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Raven from 'raven-js';
import Icon from './PropertyInformationPopoverIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function PropertyInformationPopoverFieldType({
  fieldType,
  loading
}) {
  if (loading && typeof fieldType === 'undefined') {
    return /*#__PURE__*/_jsxs(PropertyInformationPopoverValueRow, {
      children: [/*#__PURE__*/_jsx(SkeletonDiv, {
        blockSize: "18px",
        inlineSize: "16px"
      }), /*#__PURE__*/_jsx(SkeletonDiv, {
        blockSize: "18px",
        inlineSize: "120px",
        "aria-label": I18n.text('customerDataFiltersUI.propertyInformationPopover.details.fieldType.loading')
      })]
    });
  }
  if (fieldType && hasFieldTypeMessage(fieldType)) {
    return /*#__PURE__*/_jsxs(PropertyInformationPopoverValueRow, {
      children: [/*#__PURE__*/_jsx(Icon, {
        IconComponent: fieldTypeIcons[fieldType]
      }), /*#__PURE__*/_jsx(Text, {
        truncate: true,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: fieldTypeMessages[fieldType]
        })
      })]
    });
  } else {
    // missing or unknown field type
    Raven.capturePageEvent('prop-info-pop-missing-field-type', {
      extra: {
        fieldType
      }
    });
    return /*#__PURE__*/_jsx(PropertyInformationPopoverValueRow, {
      children: /*#__PURE__*/_jsx(Text, {
        truncate: true,
        use: "disabled",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFiltersUI.propertyInformationPopover.details.fieldType.unknown"
        })
      })
    });
  }
}